import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const HypoallergicRoomIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "HypoallergicRoomIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M13.3397 10.6859C10.8888 10.6859 8.89493 12.6799 8.89493 15.1307C8.89493 17.5815 10.8888 19.5755 13.3397 19.5755C15.7905 19.5755 17.7844 17.5815 17.7844 15.1307C17.7844 12.6799 15.7905 10.6859 13.3397 10.6859ZM13.3397 18.416C11.5282 18.416 10.0544 16.9422 10.0544 15.1307C10.0544 13.3192 11.5282 11.8454 13.3397 11.8454C15.1512 11.8454 16.6249 13.3192 16.6249 15.1307C16.6249 16.9422 15.1512 18.416 13.3397 18.416Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.47 13.6276L12.6936 15.404L12.0104 14.7208C11.7839 14.4944 11.4169 14.4944 11.1905 14.7208C10.9641 14.9472 10.9641 15.3142 11.1905 15.5407L12.2837 16.6338C12.5101 16.8602 12.8771 16.8602 13.1035 16.6338L15.2899 14.4475C15.5163 14.2211 15.5163 13.854 15.2899 13.6276C15.0635 13.4012 14.6964 13.4011 14.47 13.6276Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.0127 11.0567L13.8375 2.38819C13.6125 2.01143 13.0668 2.01143 12.8419 2.38819L10.7771 5.84672C10.6345 5.63047 10.468 5.42621 10.2776 5.23578L10.2673 5.22569C9.38822 4.3893 8.53286 4.03689 7.77814 3.72595C6.96135 3.38942 6.31616 3.12363 5.7167 2.33462C5.46076 1.99778 4.94192 2.03964 4.74326 2.41312C4.72366 2.44995 4.26218 3.32774 4.10391 4.51035C3.88762 6.12619 4.33438 7.54141 5.39594 8.60293C6.22475 9.43174 7.32013 9.82992 8.28789 10.0162L7.66667 11.0568C6.93626 12.2803 6.55015 13.6801 6.55015 15.105C6.55015 18.8487 9.59589 21.8945 13.3397 21.8945C17.0835 21.8945 20.1292 18.8487 20.1292 15.105C20.1292 13.6801 19.7431 12.2802 19.0127 11.0567ZM5.24876 4.6978C5.29386 4.34272 5.37352 4.0181 5.45708 3.74778C6.06547 4.27439 6.70876 4.53941 7.33644 4.79802C8.05958 5.09593 8.74268 5.37738 9.4627 6.06064C10.2452 6.84686 10.2998 7.79247 10.2008 8.46352L8.14342 6.4061C7.91701 6.17969 7.54995 6.17969 7.32354 6.4061C7.09713 6.63251 7.09713 6.99957 7.32354 7.22598L9.05939 8.96187C8.15784 8.8615 7.00351 8.57069 6.21579 7.783C5.41562 6.98283 5.09026 5.9448 5.24876 4.6978ZM13.3397 20.735C10.2353 20.735 7.70965 18.2093 7.70965 15.1049C7.70965 13.8893 8.03903 12.6949 8.66222 11.6511L9.55125 10.162C9.69313 10.1681 9.82435 10.1707 9.94104 10.1707C10.2866 10.1707 10.5105 10.1501 10.5441 10.1468C10.7477 10.1267 10.9256 10.0008 11.0124 9.81554C11.025 9.7886 11.3221 9.14515 11.3831 8.27576C11.4095 7.90085 11.3889 7.53921 11.323 7.19429L13.3396 3.81635L18.0171 11.6511C18.6403 12.6949 18.9697 13.8893 18.9697 15.105C18.9697 18.2094 16.4441 20.735 13.3397 20.735Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default HypoallergicRoomIcon;
